import React from 'react';
import './AccessibilityPage.scss';

const AccessibilityPage: React.FC = () => {
  return (
    <div className="policy-page accessibility-page">
      <div className="policy-page__container">
        <h1 className="policy-page__title">Accessibility</h1>
        <p className="policy-page__updated">Last updated: December 30, 2024</p>

        <div className="policy-page__intro">
          <p>
            $HTROM is committed to ensuring digital accessibility for all users, 
            including people with disabilities. We are continually working to improve 
            the accessibility and usability of our website.
          </p>
        </div>

        <div className="policy-page__content">
          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Our Commitment</h2>
            <p>
              We aim to make our website accessible by following generally recognized 
              accessibility standards and best practices, including the Web Content 
              Accessibility Guidelines (WCAG).
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Accessibility Features</h2>
            <ul className="policy-page__list">
              <li>Clear, readable fonts and layouts</li>
              <li>Sufficient color contrast</li>
              <li>Keyboard navigation support</li>
              <li>Screen reader compatibility</li>
            </ul>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Third-Party Content</h2>
            <p>
              Our website may include third-party applications or services. While we 
              strive to work with accessible partners, we do not control the 
              accessibility of third-party platforms.
            </p>
          </section>

          <section className="policy-page__section">
            <h2 className="policy-page__section-title">Feedback</h2>
            <p>
              If you experience difficulty accessing any part of our website, please 
              contact us. Include details about the issue and the device or browser 
              you are using.
            </p>
            <p className="policy-page__contact">
              <a href="mailto:support@shtromstudio.com">support@shtromstudio.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default AccessibilityPage;
